export const HEADER_LINKS = [
  { link: '', label: 'Home' },
  { link: 'about', label: 'About' },
  { link: 'contact', label: 'Contact' },
];
